import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCalloutStore = defineStore('callout', () => {
  const openId = ref(null)

  function open(id) {
    openId.value = id
  }

  function close(id) {
    if (openId.value === id) {
      openId.value = null
    }
  }

  function closeAll() {
    openId.value = null
  }

  return {
    openId,
    open,
    close,
    closeAll
  }
})
